// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AwsEksNodeGroupTopology = {
  EksNodeGroupTopologyMultiZone: 'multi-zone',
  EksNodeGroupTopologySingleMixedZone: 'single-mixed-zone',
} as const;
export type AwsEksNodeGroupTopology =
  (typeof AwsEksNodeGroupTopology)[keyof typeof AwsEksNodeGroupTopology];

export function instanceOfAwsEksNodeGroupTopology(value: any): boolean {
  for (const key in AwsEksNodeGroupTopology) {
    if (Object.prototype.hasOwnProperty.call(AwsEksNodeGroupTopology, key)) {
      if (
        AwsEksNodeGroupTopology[key as keyof typeof AwsEksNodeGroupTopology] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AwsEksNodeGroupTopologyFromJSON(
  json: any,
): AwsEksNodeGroupTopology {
  return AwsEksNodeGroupTopologyFromJSONTyped(json, false);
}

export function AwsEksNodeGroupTopologyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsEksNodeGroupTopology {
  return json as AwsEksNodeGroupTopology;
}

export function AwsEksNodeGroupTopologyToJSON(
  value?: AwsEksNodeGroupTopology | null,
): any {
  return value as any;
}

export function AwsEksNodeGroupTopologyToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AwsEksNodeGroupTopology {
  return value as AwsEksNodeGroupTopology;
}
